import { Directive, input } from '@angular/core';

@Directive()
export abstract class Stylable {
  styles = input<Record<string, string>>({});
  styleClass = input<string>('');
}
